import { render, staticRenderFns } from "./add-edit-dialog.vue?vue&type=template&id=ed260468&scoped=true&"
import script from "./add-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./add-edit-dialog.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-dialog.vue?vue&type=style&index=0&id=ed260468&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed260468",
  null
  
)

export default component.exports